import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { usePreviousValue } from '@wix/da-hooks/pkg/usePreviousValue';
import { getModuleRequestsPath } from '../redux/selectors/modules';
import { fetchModuleEndpoint, fetchModuleEndpointPurgeData } from '../redux/actions/modules';
import { useGruser } from './useGruser';
export function useModuleEndpoint(moduleId, path = '/') {
    var _response_config;
    const dispatch = useDispatch();
    const { gruser } = useGruser();
    const { fetchedPath, response, isFetching, errorDescription: error } = useSelector((state)=>getModuleRequestsPath(state, gruser, moduleId, path)) || {};
    const wasFetching = usePreviousValue(isFetching);
    const hasJustFinishedFetching = wasFetching && !isFetching;
    const moduleVersion = response === null || response === void 0 ? void 0 : (_response_config = response.config) === null || _response_config === void 0 ? void 0 : _response_config.version;
    const reset = useCallback(()=>{
        dispatch(fetchModuleEndpointPurgeData(gruser, {
            id: moduleId,
            path
        }));
    }, [
        dispatch,
        gruser,
        moduleId,
        path
    ]);
    const fetchEndpoint = useCallback(({ data, method = 'get' })=>{
        if (!isFetching) {
            dispatch(fetchModuleEndpoint(gruser, _object_spread_props(_object_spread({}, data), {
                id: moduleId,
                path,
                method,
                version: moduleVersion
            })));
        }
    }, [
        isFetching,
        moduleVersion,
        dispatch,
        gruser,
        moduleId,
        path
    ]);
    const getEndpoint = useCallback((data = {})=>fetchEndpoint({
            data,
            method: 'get'
        }), [
        fetchEndpoint
    ]);
    const postEndpoint = useCallback((data = {})=>fetchEndpoint({
            data,
            method: 'post'
        }), [
        fetchEndpoint
    ]);
    return {
        getEndpoint,
        postEndpoint,
        fetchEndpoint,
        isFetching,
        hasJustFinishedFetching,
        fetchedPath,
        response,
        error,
        reset
    };
}
export default useModuleEndpoint;

//# sourceMappingURL=useModuleEndpoint.js.map